import { DividedBlurb } from 'components/Containers';
import AltcsDecision from 'components/patient/blurbs/patientOverview/AltcsDecision';
import AltcsPending from 'components/patient/blurbs/patientOverview/AltcsPending';
import CoManagementTeam from 'components/patient/blurbs/patientOverview/CoManagementTeam';
import PatientRehabState from 'components/patient/blurbs/patientOverview/PatientRehabState';
import AccessGuard from 'components/shared/AccessGuard';
import { Flags } from 'constants/flags';
import { SKILLED_NURSING_FACILITY } from 'constants/locationTypes';
import Episode from 'models/Episode';
import LocationEpisode from 'models/LocationEpisode';
import { PERMISSIONS } from 'models/Profile';

type Props = { locationEpisode: LocationEpisode; episode: Episode };

export default function PatientOverview({ episode, locationEpisode }: Props) {
  const altcsApplication = locationEpisode?.altcsApplicationReview;
  const showAltcs =
    !locationEpisode?.archived &&
    locationEpisode?.owner.client.hasFlag(Flags.AltcsPending) &&
    locationEpisode?.group?.groupType?.apiName === SKILLED_NURSING_FACILITY &&
    locationEpisode.currentRehabState.inTreatment;

  const patientName = episode.patient.name;

  return (
    <DividedBlurb>
      <PatientRehabState locationEpisode={locationEpisode} episode={episode} patientName={patientName} />
      <CoManagementTeam locationEpisode={locationEpisode} episode={episode} />
      {showAltcs && (
        <AccessGuard
          accessor={PERMISSIONS.reviewAltcsApplicationEdit}
          locationEpisode={locationEpisode}
          episode={episode}>
          {altcsApplication ? (
            <AltcsDecision
              altcsApplication={altcsApplication}
              locationEpisode={locationEpisode}
              patientName={patientName}
            />
          ) : (
            <AltcsPending locationEpisode={locationEpisode} patientName={patientName} />
          )}
        </AccessGuard>
      )}
    </DividedBlurb>
  );
}
